import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  clearProveedorCostos,
  clearProveedorGeos,
  clearAceptacionNotificacion,
  setFolderPagina,
  startGetAsistenciaFiles,
  startGetAceptacionNotificacion,
  startLoadAsistencia,
} from "../../context/actions/detalleActions";
import { Spinner } from "../../layout/Spinner";
import { Folder } from "./folder/Folder";
import { Header } from "./header/Header";
import { Etapas } from "./step/Etapas";
import { PAGINA_DETALLE } from "../../constants/cons";

export const DetalleServicio = () => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();
  const { loadingDetalle } = useSelector((state) => state.detalleReducer);

  useEffect(() => {
    dispatch(clearAceptacionNotificacion());
    dispatch(startLoadAsistencia(asistenciaID));
    dispatch(startGetAsistenciaFiles(asistenciaID));
    dispatch(startGetAceptacionNotificacion(asistenciaID, false));
    dispatch(setFolderPagina(PAGINA_DETALLE.proveedor));
    dispatch(clearProveedorGeos());
    dispatch(clearProveedorCostos());
  }, [dispatch, asistenciaID]);

  //useReloadDetalle()

  if (loadingDetalle) return <Spinner size="large" />;

  return (
    <>
      <Header />
      <Etapas />
      <Folder />
    </>
  );
};
